import React from "react";
import Reveal from "@/components/marketing/Reveal";

/**
 * Ledger variant of HowItWorks — full-width rows with muted index numbers
 * and hairline dividers instead of equal card boxes. Left-aligned as one
 * composition: eyebrow, heading, and rows share the same left edge within
 * an ~800px column centered in the page container.
 */
const DEFAULT_STEPS = [
  { title: "Choose your outlets", desc: "Pick one publication or as many as you want from our list." },
  { title: "Submit your content", desc: "Send us your article or brief. We accept press releases, thought leadership, op-eds, and guest posts." },
  { title: "We place it", desc: "Our team handles placement on the named publication, with same-day submission." },
  { title: "Get your live link", desc: "You receive the live published link once your article goes live." },
];

export default function HowItWorksLedger({ steps = DEFAULT_STEPS, tag = "HOW IT WORKS", title = "How it works" }) {
  return (
    <section className="py-7 sm:py-9 lg:py-12 bg-slate/30">
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <span className="meta-tag inline-block mb-5">{tag}</span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-bone leading-tight mb-10">{title}</h2>
        </Reveal>
        <Reveal variant="card" delay={0.08}>
          <div className="divide-y divide-[#e8e6ef] border-t border-[#e8e6ef]">
          {steps.map((step, i) => (
            <div key={step.title} className="flex items-start gap-6 py-6">
              <span className="font-heading text-[28px] font-bold text-[#d8d5e2] leading-none shrink-0 w-12">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-heading text-lg font-semibold text-bone mb-1">{step.title}</h3>
                <p className="text-sm text-steel leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}